import { render, staticRenderFns } from "./Honoraires.vue?vue&type=template&id=5144295d&"
import script from "./Honoraires.vue?vue&type=script&lang=js&"
export * from "./Honoraires.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports